// **********************************************************
// Product Showcase
// **********************************************************

const productShowcaseMainEle = document.querySelectorAll('[data-slider="product-showcase-main"]');
const productShowcaseThumbEle = document.querySelectorAll('[data-slider="product-showcase-thumb"]');

// *******************************************************************************
// 1.1 - Product Showcase Thumb Slider
// *******************************************************************************

const productShowcaseThumbOptions = {
  direction: 'vertical',
  slidesPerView: 'auto',
  spaceBetween: 6,
  watchOverflow: true,
  allowTouchMove: false,
  breakpoints: {
    1199: {
      spaceBetween: 6,
    },
  },
};

productShowcaseThumbEle.forEach((el) => new Swiper(el, productShowcaseThumbOptions));

// *******************************************************************************
// 1.2 -Product Showcase Main Slider
// *******************************************************************************

const productShowcaseMainOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  watchOverflow: true,
  freeMode: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  effect: windowWidth() > 1023 ? 'fade' : 'slide',
  fadeEffect: windowWidth() > 1023 ? { crossFade: true } : undefined,
  thumbs: {
    swiper: false,
  },
  breakpoints: {
    1023: {
      slidesPerView: 1,
      spaceBetween: 20,
      freeMode: false,
    },
  },
};

const initProductShowcaseSlider = (el) => {
  const productSliderParent = el.closest('.product-showcase');
  const productSliderMain = productSliderParent.querySelector('.product-showcase__main');
  const pagination = productSliderMain.querySelector('.swiper-pagination');
  const thumbBox = productShowcaseThumbEle[[...productShowcaseMainEle].indexOf(el)];

  const options = {
    ...productShowcaseMainOptions,
    pagination: {
      ...productShowcaseMainOptions.pagination,
      el: pagination,
    },
    thumbs: {
      swiper: thumbBox?.swiper || false,
      autoScroll: false,
    },
    on: {
      slideChange: ({ realIndex }) => {
        const active = thumbBox?.querySelectorAll('.swiper-slide')[realIndex];
        if (!active) return;
        thumbBox.scrollTo({
          top: active.offsetTop - (thumbBox.clientHeight - active.offsetHeight) / 2,
          behavior: 'smooth',
        });
      },
    },
  };

  new Swiper(el, options);
};

setupResponsiveSliders({
  sliderElements: productShowcaseMainEle,
  breakpoint: breakpointSm,
  initSlider: initProductShowcaseSlider,
  mobileFallback: enablePaginationSync,
  parentSelector: '[data-slider-parent]',
});
